import {
	JobTitleCompetenciesPartialFragment,
	UserCompetenciesPartialFragment,
} from '@treams/treams-network';

import { GrowthPathAppraisal, GrowthPathJobCompetency, GrowthPathJobTitle } from './types';

export interface GrowthPathData {
	jobTitle?: GrowthPathJobTitle;
	appraisals: GrowthPathAppraisal[];
	jobCompetencies: GrowthPathJobCompetency[];
	hasCompetenciesWithoutLabel: boolean;
}

export function growthPathDataMappingFromUser(
	user: UserCompetenciesPartialFragment,
	jobTitleID?: string,
): GrowthPathData {
	const { jobPositions } = user;

	const jobCompetencies = jobPositions
		.filter((jobPosition) => {
			if (!jobTitleID || jobTitleID === 'all') {
				return true;
			}
			return jobPosition.jobTitle.id === jobTitleID;
		})
		.flatMap(({ competencies }) => competencies);

	const appraisals = jobPositions.flatMap(({ appraisal }) => appraisal);

	const hasCompetenciesWithoutLabel = jobCompetencies.some(
		(jobCompetency) => jobCompetency.competency.label === null,
	);

	return {
		appraisals,
		jobCompetencies,
		jobTitle: jobTitleID
			? jobPositions.find((jobPosition) => {
					return jobPosition.jobTitle.id === jobTitleID;
				})?.jobTitle
			: undefined,
		hasCompetenciesWithoutLabel,
	};
}

export function growthPathDataMappingFromJobTitle(
	jobTitle?: JobTitleCompetenciesPartialFragment,
): GrowthPathData {
	const jobCompetencies = jobTitle?.competencies ?? [];
	const appraisals = jobTitle?.appraisal ?? [];
	const hasCompetenciesWithoutLabel = jobCompetencies.some(
		(jobCompetency) => jobCompetency.competency.label === null,
	);

	return {
		appraisals,
		jobCompetencies,
		jobTitle,
		hasCompetenciesWithoutLabel,
	};
}
